module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/All-in-one Front Facing Camera.87701e81.png";